<template>
  <div>
    <q-modal
      :show="show"
      close-button
      dismissable
      extra-narrow
      :title="$t('modules.application.navbar.switch_account')"
      @close="$emit('close')"
    >
      <div :class="'-mx-2 flex w-[calc(100%+16px)] flex-col gap-1'">
        <button
          v-for="account in accounts"
          :key="account.id"
          :class="[
            'text-gray-80 flex h-8 w-full items-center justify-between gap-2 rounded-md px-2 py-1',
            session.account.id === account.id
              ? 'bg-active-secondary cursor-default'
              : 'hover:bg-gray-10 cursor-pointer',
          ]"
          type="button"
          @click="switchAccount(account.id)"
        >
          <span class="mr-4 truncate text-base font-medium">{{ account.name }}</span>
          <check-icon v-if="session.account.id === account.id" class="text-active-primary icon-m ml-auto shrink-0" />
        </button>
      </div>
    </q-modal>
    <slot v-if="accounts.length > 1" name="trigger"></slot>
  </div>
</template>

<script lang="ts" setup>
import { CheckIcon } from '@klausapp/ui-kit/icons'

import QModal from '@/components/QModal.vue'
import { session } from '@/composables/useSession'
import { useAccountList } from '@/composables/useAccountList'
import analytics from '@/utils/analytics'

defineProps<{
  show: boolean
}>()

defineEmits<{
  (e: 'close'): void
}>()

const [accounts] = useAccountList()

const switchAccount = (id: number) => {
  if (id === session.account.id) return
  analytics.navbarEvent('Clicked navbar popup item', 'Switch account')

  const url = new URL(window.location.origin)
  url.searchParams.append('account', id.toString())
  window.location.href = url.toString()
}
</script>
